import type * as Types from '../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DisconnectProviderMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  provider: Types.OauthProvider;
}>;


export type DisconnectProviderMutationPage = { readonly __typename?: 'RootMutationType', readonly disconnectProvider: boolean };

export type UpdateProviderTokenMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  provider: Types.OauthProvider;
  accounts: ReadonlyArray<Types.YalperAccountInput> | Types.YalperAccountInput;
}>;


export type UpdateProviderTokenMutationPage = { readonly __typename?: 'RootMutationType', readonly updateProviderToken: { readonly __typename?: 'OauthProviderToken', readonly id: string } };


export const DisconnectProviderDocument = gql`
    mutation DisconnectProvider($companyId: ID!, $provider: OauthProvider!) {
  disconnectProvider(companyId: $companyId, provider: $provider)
}
    `;
export type DisconnectProviderMutationFn = Apollo.MutationFunction<DisconnectProviderMutationPage, DisconnectProviderMutationVariables>;

/**
 * __useDisconnectProviderMutation__
 *
 * To run a mutation, you first call `useDisconnectProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectProviderMutation, { data, loading, error }] = useDisconnectProviderMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function useDisconnectProviderMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectProviderMutationPage, DisconnectProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectProviderMutationPage, DisconnectProviderMutationVariables>(DisconnectProviderDocument, options);
      }
export type DisconnectProviderMutationHookResult = ReturnType<typeof useDisconnectProviderMutation>;
export type DisconnectProviderMutationResult = Apollo.MutationResult<DisconnectProviderMutationPage>;
export type DisconnectProviderMutationOptions = Apollo.BaseMutationOptions<DisconnectProviderMutationPage, DisconnectProviderMutationVariables>;
export const UpdateProviderTokenDocument = gql`
    mutation UpdateProviderToken($id: ID!, $provider: OauthProvider!, $accounts: [YalperAccountInput!]!) {
  updateProviderToken(id: $id, provider: $provider, accounts: $accounts) {
    id
  }
}
    `;
export type UpdateProviderTokenMutationFn = Apollo.MutationFunction<UpdateProviderTokenMutationPage, UpdateProviderTokenMutationVariables>;

/**
 * __useUpdateProviderTokenMutation__
 *
 * To run a mutation, you first call `useUpdateProviderTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProviderTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProviderTokenMutation, { data, loading, error }] = useUpdateProviderTokenMutation({
 *   variables: {
 *      id: // value for 'id'
 *      provider: // value for 'provider'
 *      accounts: // value for 'accounts'
 *   },
 * });
 */
export function useUpdateProviderTokenMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProviderTokenMutationPage, UpdateProviderTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProviderTokenMutationPage, UpdateProviderTokenMutationVariables>(UpdateProviderTokenDocument, options);
      }
export type UpdateProviderTokenMutationHookResult = ReturnType<typeof useUpdateProviderTokenMutation>;
export type UpdateProviderTokenMutationResult = Apollo.MutationResult<UpdateProviderTokenMutationPage>;
export type UpdateProviderTokenMutationOptions = Apollo.BaseMutationOptions<UpdateProviderTokenMutationPage, UpdateProviderTokenMutationVariables>;